module.exports = __webpack_public_path__ + "files/5d6be4015bde2a4e0358c8bc110deadc.png";


//////////////////
// WEBPACK FOOTER
// ./images/logo.png
// module id = 1971
// module chunks = 60